import { createMedia } from '@artsy/fresnel';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import SettingsSidebar from './SettingsSidebar';

import TopBar from 'common/layouts/AuthLayout/TopBar';
import { SidebarProvider } from 'common/contexts/SidebarContext';
import { useSidebar } from 'common/contexts/SidebarContext';

import ErrorWrapper from 'error-handling/index';

import { DomainContext } from 'common/layouts/LayoutContext';
import { DomainList } from 'common/constants/domain';
import { isCurrentUserStaffOrSuperAdmin, isCurrentUserSuperUser } from 'common/selectors/auth';

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

const MobileContainer = () => {
  const [help, setHelp] = useState(false);
  const isSuperUser = useSelector(isCurrentUserSuperUser);
  const isStaff = useSelector(isCurrentUserStaffOrSuperAdmin);
  const navigate = useNavigate();
  const { isOpen } = useSidebar();

  useEffect(() => {
    if (!isSuperUser && !isStaff) {
      navigate('/app/dashboard');
    }
  }, [isSuperUser, isStaff, navigate]);

  return (
    <>
      {/* Desktop View */}
      <Media
        greaterThan="mobile"
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <SettingsSidebar />
        <TopBar setHelp={() => setHelp(!help)} mode="settings" />

        <div
          style={{
            position: 'fixed',
            top: '50px',
            left: isOpen ? '250px' : '50px',
            right: 0,
            bottom: 0,
            width: isOpen ? 'calc(100vw - 250px)' : 'calc(100vw - 50px)',
            overflow: 'hidden',
            transition: 'left 0.3s ease-in-out, width 0.3s ease-in-out',
            backgroundColor: '#fff',
            zIndex: 1,
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              padding: '20px',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <ErrorWrapper>
              <Outlet />
            </ErrorWrapper>
          </div>
        </div>
      </Media>

      {/* Mobile View */}
      <Media at="mobile" style={{ position: 'relative' }}>
        <div
          style={{
            width: '100%',
            marginTop: '100px',
            maxWidth: '100%',
            overflowX: 'hidden',
            padding: 10,
          }}
        >
          <Outlet />
        </div>
      </Media>
    </>
  );
};

const ResponsiveContainer = ({ children }) => {
  const domain = window.location.host;
  return (
    <MediaContextProvider>
      <DomainContext.Provider
        value={DomainList?.[domain] ? DomainList?.[domain] : Object.values(DomainList)[0]}
      >
        <SidebarProvider>
          <MobileContainer>{children}</MobileContainer>
        </SidebarProvider>
      </DomainContext.Provider>
    </MediaContextProvider>
  );
};

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

export default ResponsiveContainer;
